require('../../modules/es6.math.log2');
module.exports = require('../../modules/_core').Math.log2;


//////////////////
// WEBPACK FOOTER
// ./~/.2.4.1@core-js/library/fn/math/log2.js
// module id = 204
// module chunks = 0